/**
 * مقدار را به Date تبدیل می‌کند (رشته، عدد، شیء با .date، یا Date)
 */
export function toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  if (typeof value === "number") {
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }
  if (typeof value === "object" && value.date) return toDate(value.date);
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

/**
 * تاریخ را به شمسی با ساعت نمایش می‌دهد (مناسب انقضای توکن)
 */
export function formatDateShamsi(value) {
  const date = toDate(value);
  if (!date) return "—";
  return new Intl.DateTimeFormat("fa-IR", {
    calendar: "persian",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}

/**
 * تاریخ را به شمسی بدون ساعت نمایش می‌دهد
 */
export function formatDateShamsiShort(value) {
  const date = toDate(value);
  if (!date) return "—";
  return new Intl.DateTimeFormat("fa-IR", {
    calendar: "persian",
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(date);
}
